import { useState } from 'react';
import { Lock } from 'lucide-react';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { useToast } from '@/hooks/use-toast';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function AdminLogin({ onLoginSuccess }) {
  const { toast } = useToast();
  const [loginData, setLoginData] = useState({ username: '', password: '' });

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const response = await axios.post(`${API}/admin/login`, loginData);
      if (response.data.success) {
        onLoginSuccess(response.data.token);
        toast({
          title: 'Login realizado',
          description: 'Bem-vindo ao painel administrativo.',
        });
      }
    } catch (error) {
      toast({
        title: 'Erro',
        description: 'Credenciais inválidas.',
        variant: 'destructive',
      });
    }
  };

  return (
    <div data-testid="admin-login" className="min-h-screen flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="bg-card border-2 border-border p-8 rounded-lg">
          <div className="flex items-center justify-center mb-8">
            <Lock className="w-12 h-12 text-primary" />
          </div>
          <h1 className="text-3xl font-heading font-black tracking-tight uppercase text-primary text-center mb-8">
            Painel Administrativo
          </h1>
          <form data-testid="login-form" onSubmit={handleLogin} className="space-y-4">
            <div>
              <Label htmlFor="username" className="text-sm font-bold uppercase tracking-widest text-primary mb-2">
                Usuário
              </Label>
              <Input
                id="username"
                data-testid="input-username"
                type="text"
                required
                value={loginData.username}
                onChange={(e) => setLoginData({ ...loginData, username: e.target.value })}
                className="bg-white border-2 border-border focus:border-accent focus:ring-0 rounded-sm h-12 px-4 font-body"
              />
            </div>
            <div>
              <Label htmlFor="password" className="text-sm font-bold uppercase tracking-widest text-primary mb-2">
                Senha
              </Label>
              <Input
                id="password"
                data-testid="input-password"
                type="password"
                required
                value={loginData.password}
                onChange={(e) => setLoginData({ ...loginData, password: e.target.value })}
                className="bg-white border-2 border-border focus:border-accent focus:ring-0 rounded-sm h-12 px-4 font-body"
              />
            </div>
            <Button
              type="submit"
              data-testid="login-button"
              className="w-full bg-primary text-primary-foreground hover:bg-primary/90 uppercase tracking-widest font-bold px-8 py-4 rounded-sm"
            >
              Entrar
            </Button>
          </form>
          <p className="text-xs text-foreground/50 text-center mt-4">
            Use as credenciais administrativas corretas para acessar a área de criação de visualizadores.
          </p>
        </div>
      </div>
    </div>
  );
}
